/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component } from "react";
import { api } from "api";
import "./FgaAsistanStyle.css";



class Asistant extends Component {


    componentDidMount() { }

    componentWillUnmount() { }



    chatOpen = () => {
        if (
            document.getElementById("chat-open") &&
            document.getElementById("chat-close") &&
            document.getElementById("chat-window1")
        ) {

            window.document.getElementById("chat-open").style.display = "none";
            window.document.getElementById("chat-close").style.display = "block";
            window.document.getElementById("chat-window1").style.display = "block";

            try {
                let audio1 = new window.Audio("/sound/clickUp.mp3");
                audio1.load();
                audio1.play();

            } catch (error) {

            }



        }
    }

    chatClose = () => {
        if (
            document.getElementById("chat-open") &&
            document.getElementById("chat-close") &&
            document.getElementById("chat-window1") &&
            document.getElementById("chat-window2")
        ) {

            window.document.getElementById("chat-open").style.display = "block";
            window.document.getElementById("chat-close").style.display = "none";
            window.document.getElementById("chat-window1").style.display = "none";
            window.document.getElementById("chat-window2").style.display = "none";

            try {
                let audio1 = new window.Audio("/sound/clickUp.mp3");
                audio1.load();
                audio1.play();

            } catch (error) {

            }


        }
    }
    openConversation = () => {
        if (
            document.getElementById("chat-window1") &&
            document.getElementById("chat-window2")
        ) {
            window.document.getElementById("chat-window2").style.display = "block";
            window.document.getElementById("chat-window1").style.display = "none";
            this.Wellcome();
            try {
                let audio1 = new window.Audio("/sound/clickUp.mp3");
                audio1.load();
                audio1.play();

            } catch (error) {

            }

        }
    }

    userResponse = async () => {

        if (document.getElementById("textInput")) {
            let userText = document.getElementById("textInput").value;

            if (userText !== "") {
                window.document.getElementById("messageBox").innerHTML += `<div class="first-chat">
        <p style='margin-bottom:0'>${userText}</p>
        <div class="arrowchat"></div>
      </div>`;
                let audio3 = new window.Audio("/sound/4331e9c25345461.mp3");
                audio3.load();
                audio3.play();

                window.document.getElementById("textInput").value = "";
                var objDiv = document.getElementById("messageBox");
                objDiv.scrollTop = objDiv.scrollHeight;

                // setTimeout(() => {
                //     this.adminResponse(userText);
                // }, 1000);
                await this.adminResponse(userText);
            }
        }

    }

    decodeHTMLEntities = async (text) => {
        var doc = new DOMParser().parseFromString(text, "text/html");
        return doc.documentElement.textContent;
    }


    Wellcome = async () => {
        if (document.getElementById("textInput")) {

            document.getElementById(
                "messageBox"
            ).innerHTML = ` <div class="hi-there">
            <a class="p2"> <center> Ford Gelişim Akademi <br> <b> FGAssist </center></b></a>
        </div>`;

            const message = await this.ServerProcess("[[welcome]]");
            const messageConvert = await this.decodeHTMLEntities(message);
            document.getElementById(
                "messageBox"
            ).innerHTML += `<div class="second-chat" style='margin: 14px 0px;'>
                <div class="circle" id="circle-mar"></div>
                <p style='margin-bottom:0'>${messageConvert}</p>
                <div class="arrowchat"></div>
              </div>`;
            let audio3 = new window.Audio("/sound/56de9c2d5169679.mp3");
            audio3.load();
            audio3.play();

            var objDiv = document.getElementById("messageBox");
            objDiv.scrollTop = objDiv.scrollHeight;



        }
    }

    adminResponse = async (userText) => {

        let message = await this.ServerProcess(userText);

        if (!message.includes("button")) {
            message = await this.decodeHTMLEntities(message);
        }

        // const messageConvert = await this.decodeHTMLEntities(message);

        document.getElementById(
            "messageBox"
        ).innerHTML += `<div class="second-chat">
            <div class="circle" id="circle-mar"></div>
            <p style='margin-bottom:0'>${message}</p>
            <div class="arrowchat"></div>
          </div>`;
        let audio3 = new window.Audio("/sound/56de9c2d5169679.mp3");
        audio3.load();
        audio3.play();

        var objDiv = document.getElementById("messageBox");
        objDiv.scrollTop = objDiv.scrollHeight;

    }



    ServerProcess = async (message) => {
        if (document.getElementById("div-loading")) {
            window.document.getElementById("div-loading").innerHTML = `<img src='/img/car.gif' style="width: 100px;">`;
        }
        let _return = false;
        await api.post("api/FgaAssistant/chat", {
            message: message
        }).then((response) => {
            if (response.status === 200) {

                _return = response.data.data.reply;
            }
        }).catch((err) => {
            console.error(err);
        }).finally(() => {
        });
        if (document.getElementById("div-loading")) {
            window.document.getElementById("div-loading").innerHTML = null;
        }

        return _return;
    }

    ServerStatus = async (userText) => {
        const message = await this.ServerProcess(userText);
        if (message === "True") document.getElementById("chat-open").style.display = "block";
    }


    render() {

        window.onload = function () {
            // var element = window.document.getElementById("myDIV");
            // element.classList.toggle("show");
        }

        window.self.addEventListener("keypress", (e) => {
            if (e.keyCode === 13) {

                const e = window.document.getElementById("textInput");
                if (e === window.document.activeElement) {
                    this.userResponse();
                }
            }
        })

        this.ServerStatus("[[status]]");

        return (
            <>

                <div className="chat-bar-open" id="chat-open" style={{ display: "none" }}>
                    <button
                        id="chat-open-button" style={{ padding: "0px", opacity: "1" }}
                        type="button"
                        className="collapsible close"
                        onClick={() => this.chatOpen()}
                    >
                        <img src="/img/chat_ford.png" alt="Logo" />
                    </button>
                </div>

                <div className="chat-bar-close" id="chat-close">
                    <button
                        id="chat-close-button"
                        type="button"
                        className="collapsible close"
                        onClick={() => this.chatClose()}
                    >
                        <i className="material-icons-outlined"> close </i>
                    </button>
                </div>

                <div className="chat-window" id="chat-window1">
                    <div className="hi-there">
                        <a className="p1">Merhaba 👋</a>
                        <br />
                        <a className="p2">Sorularınızı yanıtlamaya hazırım.</a>
                    </div>
                    <div className="start-conversation">
                        <h1>Ben FGAssist, size yardımcı olmak için buradayım.</h1>
                        <p className="duyuruBaslik">🤖 Otomatize sistemlerle destekleniyorum, gerçek bir kişi değilim. <br></br> 🔒 Görüşmeleriniz daha iyi hizmet verebilmemiz için kayıt altına alınır.</p>
                        <button
                            className="new-conversation"
                            type="button"
                            onClick={() => this.openConversation()}
                        >
                            <span>Yeni Görüşme Başlat</span><i className="material-icons-outlined"> send </i>
                        </button>
                        <div style={{ fontSize: "12px", position: "absolute", bottom: "5px", right: "18px", color: "#2d96cd" }}>
                            BETA 0.1
                        </div>

                    </div>
                </div>

                <div className="chat-window2" id="chat-window2">
                    <div style={{ fontSize: "12px", position: "absolute", bottom: "70px", right: "18px", color: "#2d96cd" }}>
                        BETA 0.1
                    </div>
                    <div className="message-box" id="messageBox">
                        <div className="hi-there">
                            <a className="p2">  Ford Gelişim Akademi <b>Asistanı</b></a>
                        </div>
                    </div>
                    <p id="div-loading"></p>
                    <div className="input-box">

                        <div className="surveysparrow">
                            <p> &nbsp; </p> {/* <p> Fga Assistant V1.0.0 </p> */}
                        </div>
                        <div className="write-reply">
                            <input
                                className="inputText"
                                type="text"
                                id="textInput"
                                autoComplete="off"
                                placeholder="Birşeyler Yazın ..." />
                        </div>


                        <div className="send-button">
                            <button
                                onClick={() => this.userResponse()}
                                type="submit"
                                className="send-message"
                                id="send"
                            >
                                <i className="material-icons-outlined"> send </i>
                            </button>
                        </div>



                    </div>

                </div>

            </>);
    }

}

export default Asistant;
